module.exports = __webpack_public_path__ + "img/design@2x.08e7fe1.webp";